import React from "react";
import { selectFacialForm } from "../../../store/slices/formsSlice";
import Stepper, { Step } from "../Stepper";
import PersonalHistoryPage from "../PersonalHistoryPage";
import MedicalHistoryPage from "../MedicalHistoryPage";
import ConsentSignaturePage from "../ConsentSignaturePage";
import ConfirmationPage from "../ConfirmationPage";

const FacialForm = (props) => {
  return (
    <Stepper initialStep={1}>
      <Step>
        <PersonalHistoryPage
          {...props}
          formName="facialForm"
          formSelector={selectFacialForm}
          headerTitle="FACIAL"
          pageName="Personal Information + History"
          serviceQuestion="Have you had a professional facial before?"
        />
      </Step>
      <Step>
        <MedicalHistoryPage
          {...props}
          formName="facialForm"
          formSelector={selectFacialForm}
          headerTitle="FACIAL"
          conditions={[
            "Acne",
            "Cancer/Chemo",
            "Childbirth within 120 Days",
            "Eczema",
            "Permanent Makeup in Treatment Area",
            "Previous Reaction to Waxing/Threading",
            "Psoriasis",
            "Recent Procedures (Botox, Fillers, Laser)",
            "Recent Facial Injury or Infection",
            "Rosacea",
            "Sensitive Skin",
            "Skin Thinning or Fragility",
            "Sunburn in Treatment Area",
            "Thyroid Disease",
          ]}
          productSection={{
            helper: "These may increase sensitivity during facial.",
            items: [
              "AHA/BHA Acids",
              "Accutane",
              "Benzoyl Peroxide",
              "Chemical Peels",
              "Other Active Skincare Products",
              "Recent Laser Treatments",
              "Retin-A/Retinol",
              "Tretinoin",
            ],
          }}
          skinHistoryQuestions={[
            {
              name: "skinType",
              question: "What is your skin type?",
              options: ["Normal", "Oily", "Dry", "Combo"],
            },
            {
              name: "sunExposure",
              question: "Your exposure to the sun?",
              options: ["Never", "Light", "Moderate", "Excessive"],
            },
            {
              name: "foundationType",
              question: "Type of foundation you wear?",
              options: ["None", "Liquid", "Cream", "Powder"],
            },
            {
              name: "healing",
              question: "How does your skin heal?",
              options: ["Fast", "Slow", "Scars", "Pigment"],
            },
            {
              name: "bruises",
              question: "Do you get brusises easily?",
              options: ["Yes", "No"],
            },
          ]}
        />
      </Step>
      <Step>
        <ConsentSignaturePage
          {...props}
          formName="facialForm"
          formSelector={selectFacialForm}
          consentId="facial"
          consentField="facialConsent"
          headerTitle="FACIAL"
          agreementText="I have read and fully understand all information in this agreement. I consent to the agreement and to the facial treatment."
        />
      </Step>
      <Step>
        <ConfirmationPage />
      </Step>
    </Stepper>
  );
};

export default FacialForm;
